// FETCH ALL CHECKING_DC_INWARD DETAILS
export const FETCH_CHECKING_DC_INWARD_DETAILS_REQUEST = 'FETCH_CHECKING_DC_INWARD_DETAILS_REQUEST';
export const FETCH_CHECKING_DC_INWARD_DETAILS_SUCCESS = 'FETCH_CHECKING_DC_INWARD_DETAILS_SUCCESS';
export const FETCH_CHECKING_DC_INWARD_DETAILS_FAILURE = 'FETCH_CHECKING_DC_INWARD_DETAILS_FAILURE';

// FETCH ALL CHECKING_DC_INWARD DETAILS
export const FETCH_CHECKING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_CHECKING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_CHECKING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_CHECKING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_CHECKING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_CHECKING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE';

// CREATE CHECKING_DC_INWARD DETAILS
export const CREATE_CHECKING_DC_INWARD_DETAILS_REQUEST = 'CREATE_CHECKING_DC_INWARD_DETAILS_REQUEST';
export const CREATE_CHECKING_DC_INWARD_DETAILS_SUCCESS = 'CREATE_CHECKING_DC_INWARD_DETAILS_SUCCESS';
export const CREATE_CHECKING_DC_INWARD_DETAILS_FAILURE = 'CREATE_CHECKING_DC_INWARD_DETAILS_FAILURE';

// UPDATE CHECKING_DC_INWARD DETAILS
export const UPDATE_CHECKING_DC_INWARD_DETAILS_REQUEST = 'UPDATE_CHECKING_DC_INWARD_DETAILS_REQUEST';
export const UPDATE_CHECKING_DC_INWARD_DETAILS_SUCCESS = 'UPDATE_CHECKING_DC_INWARD_DETAILS_SUCCESS';
export const UPDATE_CHECKING_DC_INWARD_DETAILS_FAILURE = 'UPDATE_CHECKING_DC_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STATE OF CHECKING_DC_INWARD DETAILS
export const FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_FAILURE';

// DELETE CHECKING_DC_INWARD DETAILS
export const DELETE_CHECKING_DC_INWARD_DETAILS_REQUEST = 'DELETE_CHECKING_DC_INWARD_DETAILS_REQUEST';
export const DELETE_CHECKING_DC_INWARD_DETAILS_SUCCESS = 'DELETE_CHECKING_DC_INWARD_DETAILS_SUCCESS';
export const DELETE_CHECKING_DC_INWARD_DETAILS_FAILURE = 'DELETE_CHECKING_DC_INWARD_DETAILS_FAILURE';

export const RESET_CHECKING_DC_INWARD_DETAILS_INFO = 'RESET_CHECKING_DC_INWARD_DETAILS_INFO';

export const CREATE_CHECKING_DC_INWARD_DETAILS_FORM = 'CREATE_CHECKING_DC_INWARD_DETAILS_FORM';

export const UPDATE_CHECKING_DC_INWARD_DETAILS_FORM = 'UPDATE_CHECKING_DC_INWARD_DETAILS_FORM';
